<template>
  <div>
    <div class="news_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>招聘详情</dt>
          <dd>news &nbsp;&nbsp; information</dd>
        </dl>
      </div>
    </div>

    <div>
      <iframe
        src="../../static/zhaopin.html"
        frameborder="0"
        style="width: 100%; height: auth"
        id="bdIframe"
      ></iframe>
    </div>
    <!-- <v-html-panel :url.asyc="html"></v-html-panel> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      html: "../../static/zhaopin.html",
    };
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById("bdIframe");
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = Number(deviceHeight) + 3600 + "px"; //数字是页面布局高度差
  },
};
</script>



// WEBPACK FOOTER //
// src/view/product.vue